/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CallOrderModel { 
    id: number;
    uniqueNumber?: string;
    total?: number;
    currency?: string;
    status?: string;
    action?: string;
    date?: string;
}

